import { render, staticRenderFns } from "./CertificationForEmployee.vue?vue&type=template&id=53470d5a&scoped=true&"
import script from "./CertificationForEmployee.vue?vue&type=script&lang=js&"
export * from "./CertificationForEmployee.vue?vue&type=script&lang=js&"
import style0 from "./CertificationForEmployee.vue?vue&type=style&index=0&id=53470d5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53470d5a",
  null
  
)

export default component.exports